import { memo } from 'react';
import { PageContainer } from '@/components/templates/PageContainer';
import { PageHeaderSkeleton, CourseCardSkeleton } from '@/components/molecules/skeletons';
import { SKELETON } from '@/lib/constants';

export const ExplorePageSkeleton = memo(() => {
  return (
    <PageContainer>
      <div className="space-y-6">
        <PageHeaderSkeleton />
        <div className="bg-card border border-border rounded-xl shadow-none p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {Array.from({ length: SKELETON.COURSE_CARDS }, (_, i) => (
              <CourseCardSkeleton key={i} />
            ))}
          </div>
        </div>
      </div>
    </PageContainer>
  );
});

ExplorePageSkeleton.displayName = 'ExplorePageSkeleton';
